import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyAccount = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/accounts',

        modules: [],
        modulesLoading: false,
        moduleLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        modules: state => state.modules,
    },
};
